import React from "react";
import { Outlet } from "react-router-dom";
import AccountPage from "@pages/Account/AccountPage/AccountPage";
import PurchaseSuccessPage from "@pages/Account/PurchaseSuccessPage/PurchaseSuccessPage";
import SubscribePage from "@pages/Account/SubscribePage/SubscribePage";

export default [
    {
        path: "account",
        element: <Outlet />,
        children: [
            {
                path: "",
                element: <AccountPage />,
            },
            {
                path: "purchase-success",
                element: <PurchaseSuccessPage />,
            },
            {
                path: "subscribe",
                element: <SubscribePage />,
            },
        ],
    },
];
